var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fa-layers',{staticClass:"fa-lg",class:[_vm.direction, { disabled: _vm.disabled }],on:{"click":_vm.click}},[_c('fa-icon',{attrs:{"icon":"circle"}}),_vm._v(" "),_c('fa-icon',{style:({ color: 'white' }),attrs:{"icon":_vm.direction == 'right' ? 'redo-alt' : 'undo-alt',"transform":"shrink-6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }